import { AxiosResponse } from 'axios'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import API from '@/lib/api'
import { useAuth } from '@/lib/auth'

interface ForgotPasswordFormProps {
  onSuccess?: (response: AxiosResponse) => void
}

interface ForgotPasswordFormValues {
  email: string
}

export const ForgotPasswordForm = ({
  onSuccess,
}: ForgotPasswordFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { csrf } = useAuth({
    middleware: 'guest',
    tmp: 'ForgotPasswordForm',
  })
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<ForgotPasswordFormValues>()

  const onSubmit = async (values: ForgotPasswordFormValues) => {
    if (isSubmitting) return
    if (Object.keys(errors).length > 0) return
    if (!values.email) return

    setIsSubmitting(true)

    await csrf()

    API.post('/api/v2/forgot-passwords', {
      email: values.email,
    })
      .then((response) => {
        setIsSubmitting(false)
        if (response.status === 200 || response.status === 204) {
          return onSuccess && onSuccess(response)
        } else {
          toast.error('Chyba přihlášení', {
            description: 'Vypadá to, že server má potíže.',
            duration: 5000,
            closeButton: true,
          })
        }
      })
      .catch((error) => {
        setIsSubmitting(false)

        toast.error('Chyba přihlášení', {
          description: 'Vypadá to, že server má potíže.',
          duration: 5000,
          closeButton: true,
        })

        console.error(error)
        return error
      })
  }

  return (
    <form method="POST" onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="space-y-2 min-w-[300px]">
        <Label htmlFor="email">E-mail</Label>
        <Input
          id="email"
          placeholder="E-mail k Vašemu účtu"
          disabled={isSubmitting}
          {...register('email', {
            required: 'Zadejte prosím e-mail k Vašemu účtu',
          })}
        />
        {errors.email && (
          <p className="text-sm text-destructive">{errors.email.message}</p>
        )}
      </div>

      <Button
        className="w-full"
        disabled={isSubmitting}
        type="submit"
      >
        {isSubmitting ? 'Odesílání...' : 'Odeslat e-mail s kódem'}
      </Button>
    </form>
  )
}
